export const getPreviousMonth = (datestring: Date) => {
  const date = new Date(datestring);
  date.setMonth(date.getMonth() - 1);
  const dateFormat =
    date.toLocaleDateString("en-US", { year: "numeric" }) +
    "-" +
    date.toLocaleDateString("en-US", { month: "numeric" }).padStart(2, "0") +
    "-" +
    date.toLocaleDateString("en-US", { day: "numeric" }).padStart(2, "0");
  return dateFormat;
};
export const getNexMonth = (datestring: Date) => {
  const date = new Date(datestring);
  date.setMonth(date.getMonth() + 1);
  const dateFormat =
    date.toLocaleDateString("en-US", { year: "numeric" }) +
    "-" +
    date.toLocaleDateString("en-US", { month: "numeric" }).padStart(2, "0") +
    "-" +
    date.toLocaleDateString("en-US", { day: "numeric" }).padStart(2, "0");
  return dateFormat;
};
export const getDateNow = (datestring: Date) => {
  const date = new Date(datestring);

  const dateFormat =
    date.toLocaleDateString("en-US", { year: "numeric" }) +
    "-" +
    date.toLocaleDateString("en-US", { month: "numeric" }).padStart(2, "0") +
    "-" +
    date.toLocaleDateString("en-US", { day: "numeric" }).padStart(2, "0");
  return dateFormat;
};

export const formatDate = (dateString: Date | string) => {
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const getCurrentDateTime = () => {
  const now = new Date();
  const offset = now.getTimezoneOffset() * 60000;
  const localISOTime = new Date(now.getTime() - offset)
    .toISOString()
    .slice(0, 16);
  return localISOTime;
};
